module.exports = __webpack_public_path__ + "img/underbust.6824b533.png";